module.exports = __webpack_public_path__ + "static/media/Original.361a812c.png";